<div class="w-full flex flex-col" *ngIf="tipoDocumentos || tiposDocumentosFicha">

    @if(this.isLoading && this.esFicha === false){
        <fuse-alert [type]="'warning'">
            <span fuseAlertTitle>Generando documento</span>
            Este proceso puede tardar unos segundos. Por favor, mantenga abierta esta ventana.
        </fuse-alert>
    }
    
    <span class="font-semibold text-2xl pt-2">Generar Nuevo Documento</span>
    <hr class="my-4">

    <form #myForm="ngForm">

        @if(!this.esFicha){
            <mat-form-field class="fuse-mat-dense w-full">
                <mat-label>Número de documento Oficial</mat-label>
                <input matInput [(ngModel)]="documentoGenerado.CodigoDocumento" 
                        name="CodigoDocumento"
                        id="CodigoDocumento" type="text" required/>
            </mat-form-field>  
        }

        <mat-form-field class="w-full fuse-mat-dense">
            <mat-label>Tipo de Documento</mat-label>
            <mat-select name="tipoDocumento" id="tipoDocumento"  
                [(ngModel)]="documentoGenerado.tipoDocumento" 
                [disabled]="this.esFicha" required>
                @for (tipo of (this.esFicha ?tiposDocumentosFicha:tipoDocumentos); track tipo) {
                    @if(!(this.esFicha === false && tipo.tipologiaId === TIPOLOGIA_ID_FICHA_DE_REGISTRO)){
                        <mat-option [value]="tipo">{{tipo.descripcion | uppercase }}</mat-option>
                    }
                
                }
            </mat-select>
        </mat-form-field> 

        <mat-form-field class="w-full fuse-mat-dense">
            <mat-label>Vigencia en Meses</mat-label>
            <input matInput type="number" id="vigencia" name="vigencia" placeholder="vigencia" 
                [(ngModel)]="documentoGenerado.vigencia" required/>
        </mat-form-field>

        <mat-form-field class="fuse-mat-dense w-full">
            <mat-label>Elaborado Por</mat-label>
            <input matInput [(ngModel)]="documentoGenerado.generadoPor" 
                    name="generadoPor"
                    id="generadoPor" type="text" required/>
        </mat-form-field>  

        <hr class="my-2">

        <mat-form-field class="w-full">
            <mat-label>Gestiones Asociadas</mat-label>
            <input
                matInput
                placeholder="Buscar gestión..."
                #fruitInput
                id="gestionActual"
                name="gestionActual"
                [(ngModel)]="gestionActual"
                [matAutocomplete]="auto"
                (input)="onInputChange()"   
                />
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event);">
                <mat-option *ngFor="let gestion of filteredGestiones" [value]="gestion.nombre">
                {{ gestion.nombre }}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
       
        <table mat-table [dataSource]="gestionesSeleccionadas"  class="w-full">
            <!-- Nombre Column -->
            <ng-container matColumnDef="nombre">
                <td mat-cell *matCellDef="let gestion"> {{gestion.nombre}} </td>
            </ng-container>

            <!-- acciones Column -->
            <ng-container matColumnDef="acciones">
                <td mat-cell *matCellDef="let gestion">
                    <button mat-icon-button (click)="remove(gestion)">
                        <mat-icon>delete</mat-icon>
                    </button>
                    <!--<button mat-icon-button (click)="abrirGestion(gestion.gestionUuid)">
                        <mat-icon>visibility</mat-icon>
                    </button>-->
                </td>
            </ng-container>

            <tr mat-row *matRowDef="let row; columns: ['nombre', 'acciones']" class="border-b"></tr>
        </table>
    </form>


    <div class="w-full flex justify-center md:justify-end gap-3 mt-3">
        <button mat-button mat-raised-button
            class="rounded-sm"  
            [color]="'secondary'" 
            [disabled]="this.isLoading"
            (click)="this.dialogRef.close(false);">
            Cancelar
        </button>

        <button mat-flat-button 
            [color]="'primary'" 
            class="rounded-sm"
            type="submit"
            (click)="emitirFichaDocumento(this.esFicha)"
            [disabled]="!(myForm.valid && gestionesSeleccionadas.length > 0) || this.isLoading">Generar Documento
        </button>
    </div>

</div>